// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2MxGQ","notes":"Notes_notes__3TJBh","note":"Notes_note__3ydnI","markdown":"Notes_markdown__YodG5"};